import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowRatingComponent } from './show-rating/show-rating.component';
import { SubmitRatingComponent } from './submit-rating/submit-rating.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ShowRatingComponent,
    SubmitRatingComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports:[
    ShowRatingComponent,
    SubmitRatingComponent
  ]
})
export class RatingModule { }
